export default __webpack_public_path__ + "static/media/wheel.f35bf8d7.svg";